var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRejectRedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 120,
    height: 120,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Reject_-_SVG_icon_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Reject_-_SVG_icon_1",
    "data-name": "Reject - SVG icon \\u2013 1",
    clipPath: "url(#clip-Reject_-_SVG_icon_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(-216 -81)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M855.414,554.89l3.293-3.293a1,1,0,0,0-1.414-1.414L854,553.476l-3.293-3.293a1,1,0,0,0-1.414,1.414l3.293,3.293-3.293,3.293a1,1,0,1,0,1.414,1.414L854,556.3l3.293,3.293a1,1,0,1,0,1.414-1.414Z",
    transform: "translate(-603 -438.89)",
    fill: "#c42525"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(-248.2 -755)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4006",
    "data-name": "Path 4006",
    d: "M27.2,12.2a15,15,0,1,0,15,15A15,15,0,0,0,27.2,12.2Zm0,27.554A12.554,12.554,0,1,1,39.754,27.2,12.554,12.554,0,0,1,27.2,39.754Z",
    transform: "translate(472 843.8)",
    fill: "#c42525"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectRedIcon);
export default __webpack_public_path__ + "static/media/rejectRedIcon.e64fb2be421f2a3ac8c93990ade72a2e.svg";
export { ForwardRef as ReactComponent };